import * as React from "react";
import { forwardRef } from "react";
const SvgCompass = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6ZM5.4 18.6L14.412 14.412L18.6 5.4L9.588 9.588L5.4 18.6ZM12 10.68C12.732 10.68 13.32 11.268 13.32 12C13.32 12.732 12.732 13.32 12 13.32C11.268 13.32 10.68 12.732 10.68 12C10.68 11.268 11.268 10.68 12 10.68Z" }));
const ForwardRef = forwardRef(SvgCompass);
export default ForwardRef;
